import React from 'react';
import styled from 'styled-components';
import { z50 } from '../theme/z-index';
export const Wrapper = styled.div`
  position: fixed;
  display: flex;
  z-index: ${z50};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(1px);

  > * {
    margin: auto;
  }
`;
const DialogWrapper = ({
  children,
  className
}) => /*#__PURE__*/React.createElement(Wrapper, {
  className
}, children);
export default DialogWrapper;
//# sourceMappingURL=index.js.map